import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyUploadedMediaFile,
  orderSelector,
  setDisputeMedia,
} from "../../../../../../redux/slices/orderSlice";
import axiosProtected from "../../../../../../api/config/baseWithToken";

export default function DisputeMediaSendAsMessage({ fileLink, setFileLink }) {
  const { disputeMedia } = useSelector(orderSelector);
  const dispatch = useDispatch();
  // const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedMediaFile, setUploadedMediaFile] = useState(null);

  const uploadMedia = async () => {
    const formData = new FormData();
    formData.append("media", fileLink);
    setIsLoading(true);
    try {
      const { data } = await axiosProtected.post(`/store/upload`, formData);
      setIsLoading(false);
      setUploadedMediaFile(data);
  
      return data;
    } catch (error) {
      console.error("Error uploading media:", error);
      throw error; // Propagate the error
    }
  };

  useEffect(() => {
    const handleFileUpload = async () => {
      if (fileLink) {
        dispatch(emptyUploadedMediaFile(null));

        try {
          await uploadMedia();
          // setMediaUploadLoading(false);
        } catch (error) {
          console.log(error);
        }
      }
    };

    handleFileUpload();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileLink]);

  useEffect(() => {
    // uploadedMediaFile?.media && setMediaUploadLoading(false);
    dispatch(setDisputeMedia([...disputeMedia, uploadedMediaFile?.media]));
    setFileLink(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedMediaFile?.media]);

  useEffect(() => {
    return () => {
      dispatch(emptyUploadedMediaFile(null));
    };
  }, [dispatch]);
  return (
    <div
      style={{
        marginBottom: "20px",
      }}
    >
      <div>
        {isLoading
          ? "File uploading..."
          : uploadedMediaFile?.media &&
            disputeMedia?.length > 0 &&
            disputeMedia
              ?.filter((item) => item)
              .map((item, index) => (
                <div style={{ display: "flex" }}>
                  <Tooltip
                    componentsProps={{
                      tooltip: {
                        sx: {
                          backgroundColor: "#ffffff",
                          boxShadow:
                            "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.35) 0px 12px 24px -4px",
                          color: "black",
                          fontSize: "13px",
                          fontWeight: 500,
                          padding: "15px",
                          textAlign: "left",

                          maxWidth: "450px",
                        },
                      },
                      arrow: {
                        sx: {
                          fontSize: 16,
                          color: "#ffffff",
                        },
                      },
                    }}
                    title={
                      <img
                        src={item}
                        style={{ width: "100%", height: "100%" }} // Set the image size to 100% of the tooltip container
                        alt="receipt"
                      />
                    }
                    placement="top"
                    arrow
                  >
                    <a
                      href={item}
                      target="_blank"
                      style={{
                        textDecoration: "underline",
                        marginRight: "5px",
                      }}
                      rel="noreferrer"
                    >
                      {`File #${index + 1}`}
                    </a>
                  </Tooltip>
                </div>
              ))}
      </div>
    </div>
  );
}
